import { localizedMessagesService } from '@services/requests/localizedMessagesService';
import { LocalizedMessagesServiceInterfaces } from '@services/requests/localizedMessagesService/interfaces';
import { $error } from '@settings/errorContext';
import { graphQLClient } from '@settings/services/graphQLClient';
import { GraphQLClient } from '@settings/services/graphQLClient/GraphQLClient';

import { LoaderInterface } from '../interface';
import {
  UnitGroupData,
  UnitGroupLoaderQuery,
  UnitGroupLoaderQueryResponse,
} from './UnitGroupLoaderQuery';

/**
 * Загрузчик данных по группам единиц измерения
 */
export class UnitGroupLoader implements LoaderInterface<UnitGroupData> {
  private readonly client: GraphQLClient;
  private readonly localizationLoader: LocalizedMessagesServiceInterfaces;

  constructor(token?: string) {
    this.client = graphQLClient(token);
    this.localizationLoader = localizedMessagesService(token);
  }

  async Load(primaryKeys?: any[]): Promise<UnitGroupData[]> {
    try {
      const resp = await this.client.Query<null, UnitGroupLoaderQueryResponse>(
        new UnitGroupLoaderQuery(primaryKeys),
        {}
      );

      // Формируем общий список локализаций (ID)
      const localizedMessageIds = resp.items.reduce(
        (result: string[], item: UnitGroupData): string[] => [...result, ...item.localized_names],
        []
      );

      // Загружаем все локализованные тексты
      const messages = await this.localizationLoader.GetMessagesArray(localizedMessageIds);
      resp.items.map((item) => {
        item.localized_names_data = messages.filter(
          (m) => item.localized_names.indexOf(m.id) !== -1
        );
      });

      return resp.items;
    } catch (e) {
      $error.next(e);
    }
  }
}
